var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.571 17.143h-5.428v5.428a.287.287 0 0 1-.286.286h-1.714a.287.287 0 0 1-.286-.286v-5.428H9.43a.287.287 0 0 1-.286-.286v-1.714c0-.157.128-.286.286-.286h5.428V9.43c0-.158.129-.286.286-.286h1.714c.157 0 .286.128.286.286v5.428h5.428c.158 0 .286.129.286.286v1.714a.287.287 0 0 1-.286.286"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 32C7.164 32 0 24.836 0 16S7.164 0 16 0s16 7.164 16 16-7.164 16-16 16m0-29.286C8.664 2.714 2.714 8.664 2.714 16S8.664 29.286 16 29.286 29.286 23.336 29.286 16 23.336 2.714 16 2.714"
  })));
};
export default SvgPlus;